
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const GoogleAuthCallbackPage = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const code = searchParams.get('code');
    const error = searchParams.get('error');

    // Check if this is a GMB OAuth return (no opener means full redirect)
    const isGMBOAuth = !window.opener && (sessionStorage.getItem('gmb_oauth_brand_id') || searchParams.get('state')?.includes('gmb'));

    if (error) {
      if (isGMBOAuth) {
        // Handle GMB OAuth error - redirect back with error
        const returnUrl = sessionStorage.getItem('gmb_oauth_return_url') || '/integrations';
        sessionStorage.removeItem('gmb_oauth_return_url');
        sessionStorage.removeItem('gmb_oauth_brand_id');
        
        // Store error in sessionStorage and redirect
        sessionStorage.setItem('gmb_oauth_error', error);
        window.location.href = returnUrl;
        return;
      } else {
        // Send error message to parent window (popup flow)
        window.opener?.postMessage({
          type: 'GOOGLE_AUTH_ERROR',
          error: error
        }, window.location.origin);
        window.close();
        return;
      }
    }

    if (code) {
      if (isGMBOAuth) {
        // Handle GMB OAuth success - redirect back with success
        const returnUrl = sessionStorage.getItem('gmb_oauth_return_url') || '/integrations';
        const brandId = sessionStorage.getItem('gmb_oauth_brand_id');
        
        sessionStorage.removeItem('gmb_oauth_return_url');
        sessionStorage.removeItem('gmb_oauth_brand_id');
        
        // Store success info and redirect
        sessionStorage.setItem('gmb_oauth_success', 'true');
        sessionStorage.setItem('gmb_oauth_code', code);
        if (brandId) sessionStorage.setItem('gmb_oauth_brand_id_success', brandId);
        
        window.location.href = returnUrl;
        return;
      } else {
        // Regular Google OAuth popup flow
        // In a real implementation, you would exchange the code for tokens
        // and get user info. For now, we'll simulate this with a placeholder email
        
        // You would typically make a request to your backend here
        // to exchange the authorization code for access tokens
        
        // For demo purposes, we'll use a placeholder email
        // In production, you'd get this from the Google API after token exchange
        const userEmail = "user@example.com"; // This should come from Google API
        
        window.opener?.postMessage({
          type: 'GOOGLE_AUTH_SUCCESS',
          email: userEmail,
          code: code
        }, window.location.origin);
        
        window.close();
      }
    }
  }, [searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Processing authentication...</p>
      </div>
    </div>
  );
};

export default GoogleAuthCallbackPage;
